import {
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { filterPlaceholders } from '../../search/advanced-search/filter-placeholders';
import {
  REGION_TYPE, VEHICLE_TYPE, YEAR_START_TYPE, YEAR_END_TYPE,
} from '../../search/advanced-search/filter-types';
import { BaseAdvancedSearchComponent } from '../../search/advanced-search/_base-advanced-search.component';
import { VehicleSearchComponent } from '../../search/vehicle-search/vehicle-search.component';
import { VehicleAttributesSearchComponent } from '../../search/vehicle-attributes-search/vehicle-attributes-search.component';

import { BrandService } from '../../brand/brand.service';
import { FitmentsService } from '../../fitments/fitments.service';
import { AdvancedSearchService } from '../../search/advanced-search/advanced-search.service';


@Component({
  moduleId: module.id,
  selector: 'fitments-advanced-search',
  templateUrl: 'fitments-advanced-search.component.html',
  styleUrls: ['fitments-advanced-search.component.scss'],
})
export class FitmentsAdvancedSearchComponent extends BaseAdvancedSearchComponent {

  @Input() productId: any;
  @Input() showSearchBtns: boolean = true;

  @ViewChild(VehicleSearchComponent, {static: true})
  declare vehicleSearch: VehicleSearchComponent | void;

  @ViewChild(VehicleAttributesSearchComponent, {static: false})
  declare vehicleAttributes: VehicleAttributesSearchComponent | void;

  attributeGroups: Array<any> = [];

  constructor(
    public brandService: BrandService,
    protected ref: ChangeDetectorRef,
    private fitmentsService: FitmentsService,
    private advancedSearchService: AdvancedSearchService,
  ) {
    super(brandService, ref);
    this.filterPlaceholders = filterPlaceholders;
  }

  private fetchOptions(filterName: string, filterSearchModel: any): Observable<any> {
    let searchModel = filterSearchModel;
    if (filterName === REGION_TYPE || filterName === VEHICLE_TYPE) {
      // do not filter regions & vehicle types
      searchModel = _.omit(searchModel, ['vehicleType', 'region']);
    }
    if (filterName.toLowerCase().indexOf('year') !== -1) {
      filterName = 'year';
    } else {
      // if maxYear is not selected, then set maxYear = minYear
      if (!searchModel[YEAR_END_TYPE]) {
        searchModel = _.assign(
          _.clone(filterSearchModel),
          {[YEAR_END_TYPE]: filterSearchModel[YEAR_START_TYPE]}
        );
      }
    }
    if (this.productId) {
      return this.fitmentsService.fetchProductYmmFilters(
        this.brandId,
        this.productId,
        filterName,
        searchModel
      );
    } else {
      return this.fitmentsService.fetchYmmFilters(filterName, searchModel);
    }
  }

  /*
    * Fetch attribute groups
    * Used by vehicle attributes search
  */
  private fetchAttributeGroups(): void {
    this.showSpinner(true);
    if (this.productId) {
      this.advancedSearchService.fetchProductGroupedFieldsList(
        this.brandId,
        'itemDetailsId',
        this.productId,
      )
      .subscribe((data: any) => {
        this.setAttributeGroups(data);
        this.showSpinner(false);
      });
    } else {
      this.advancedSearchService.fetchGroupedFieldsList()
      .subscribe((data: any) => {
        this.setAttributeGroups(data);
        this.showSpinner(false);
      });
    }
  }

  private fetchAttributes(): void {
    this.showSpinner(true);
    if (this.productId) {
      this.fitmentsService.fetchProductOptionsFieldsList(
        this.filterSearchModel,
        this.brandId,
        this.productId,
        'itemDetailsId',
      )
      .subscribe((data: any) => {
        this.attributesList = data;
        this.showSpinner(false);
      });
    } else {
      this.fitmentsService.fetchOptionsFieldsList(this.filterSearchModel)
      .subscribe((data: any) => {
        this.attributesList = data;
        this.showSpinner(false);
      });
    }
  }
}
